import {
  CLOSE_CANCEL_FUNDING_SEARCH_MATCH_MODAL,
  OPEN_CANCEL_FUNDING_SEARCH_MATCH_MODAL,
  fundingMatchStatus,
  cancelFundingSearchMatch,
  SET_FETCHING_OFFER_MATCH_IDS,
  SET_FUNDING_MATCH_NOTIFICATION,
  DELETE_FETCHING_OFFER_MATCH_ID,
  SET_IGNORED_MATCH_STATUSES,
  SSE_UPDATE_FUNDING_MATCH_SUCCESS,
  SSE_UPDATE_FUNDING_MATCH_FAILURE,
} from './types';

export const setIgnoredMatchStatuses = (matchId, statuses) => ({
  matchId,
  statuses,
  type: SET_IGNORED_MATCH_STATUSES,
});

export const requestCancelFundingSearchMatch = (fundingSearchId, matchId, promise) => ({
  payload: {
    fundingSearchId,
    matchId,
  },
  promise,
  type: cancelFundingSearchMatch.request,
});

export const requestCancelFundingSearchMatchSuccess = (payload, response) => ({
  payload,
  response,
  type: cancelFundingSearchMatch.success,
});

export const requestCancelFundingSearchMatchFailure = (error) => ({
  error,
  type: cancelFundingSearchMatch.failure,
});

export const requestUpdateMatchStatus = (fundingSearchId, fundingMatchId, status) => ({
  payload: {
    fundingSearchId,
    fundingMatchId,
    status,
  },
  type: fundingMatchStatus.request,
});

export const requestUpdateMatchStatusSuccess = (response, payload) => ({
  payload,
  response,
  type: fundingMatchStatus.success,
});

export const requestUpdateMatchStatusFailure = (error) => ({
  error,
  type: fundingMatchStatus.failure,
});

export const openCancelFundingSearchMatchModal = (matchInstance) => ({
  matchInstance,
  type: OPEN_CANCEL_FUNDING_SEARCH_MATCH_MODAL,
});

export const closeCancelFundingSearchMatchModal = () => ({
  type: CLOSE_CANCEL_FUNDING_SEARCH_MATCH_MODAL,
});

export const sseUpdateFundingMatchSuccess = (response, sseUpdateData) => ({
  response,
  sseUpdateData,
  type: SSE_UPDATE_FUNDING_MATCH_SUCCESS,
});

export const sseUpdateFundingMatchFailure = (error) => ({
  error,
  type: SSE_UPDATE_FUNDING_MATCH_FAILURE,
});

export const setFetchingOfferMatchIds = (matchId) => ({
  matchId,
  type: SET_FETCHING_OFFER_MATCH_IDS,
});

export const setFundingMatchNotification = (matchId, notification) => ({
  matchId,
  notification,
  type: SET_FUNDING_MATCH_NOTIFICATION,
});

export const deleteFetchingOfferMatchId = (matchId) => ({
  matchId,
  type: DELETE_FETCHING_OFFER_MATCH_ID,
});
